import { gql } from '@generated/gql';

export const availableBroadbandAppointments = gql(`
  query AvailableBroadbandAppointments(
    $basketId: ID!
    $after: Date
  ) {
    availableBroadbandAppointments(
      basketId: $basketId
      after: $after
    ) {
      date
      slot
    }
  }
`);

export const reservedBroadbandAppointment = gql(`
  query ReservedBroadbandAppointment(
    $basketId: ID!
  ) {
    reservedBroadbandAppointment(basketId: $basketId) {
      date
      slot
    }
  }
`);

export const reserveBroadbandAppointment = gql(`
  mutation ReserveBroadbandAppointment(
    $basketId: ID!
    $appointment: ReserveBroadbandAppointmentInput!
  ) {
    reserveBroadbandAppointment(
      basketId: $basketId
      appointment: $appointment
    ) {
      id
      appointment {
        date
        slot
      }
    }
  }
`);
